export default [
  {
    icon: 'mdi-monitor-dashboard',
    title: 'Início',
    to: '/fornecedor/dashboard',
  },
]
